
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/faq",
      function () {
        return require("private-next-pages/en/ir/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ir/faq"])
      });
    }
  